export default __webpack_public_path__ + "static/media/filter-bg.411fcf9e.jpg";